import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62b70a5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "canvas",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "nge-growing-cell-name",
  "aria-hidden": "true"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: "nge-growing-cell",
    style: _normalizeStyle({ '--nge-gc-size': $setup.props.size + 'px' })
  }, [
    _createElementVNode("canvas", _hoisted_1, null, 512 /* NEED_PATCH */),
    ($setup.props.named)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.name), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 4 /* STYLE */))
}